import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const SourceCallSingCellContent: React.FC<SourceCallSingCellContent.Props> = ({
	item,
}) => {
	const { t } = useTranslation();
	const { content, backgroundColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.SourceCallSing];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item, t);
	}, [item, t]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace SourceCallSingCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default SourceCallSingCellContent;
